const translation = {
  tags: {
    social: 'सामाजिक',
    business: 'व्यवसाय',
    agent: 'एजेंट',
    design: 'डिज़ाइन',
    education: 'शिक्षा',
    news: 'समाचार',
    productivity: 'उत्पादकता',
    weather: 'मौसम',
    utilities: 'यूटिलिटीज',
    image: 'छवि',
    search: 'खोज',
    videos: 'वीडियो',
    travel: 'यात्रा',
    entertainment: 'मनोरंजन',
    other: 'अन्य',
    medical: 'चिकित्सा',
    finance: 'वित्त',
  },
  searchTags: 'खोज टैग',
  allTags: 'सभी टैग',
}

export default translation
